/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Brief_Sources_ValueInputs */

const en_how_we_work_brief_sources_value = /** @type {(inputs: How_We_Work_Brief_Sources_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox, service guide and CRM`)
};

const lv_how_we_work_brief_sources_value = /** @type {(inputs: How_We_Work_Brief_Sources_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pastkaste, pakalpojumu apraksts un CRM`)
};

/**
* | output |
* | --- |
* | "Inbox, service guide and CRM" |
*
* @param {How_We_Work_Brief_Sources_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_brief_sources_value = /** @type {((inputs?: How_We_Work_Brief_Sources_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Brief_Sources_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_brief_sources_value(inputs)
	return en_how_we_work_brief_sources_value(inputs)
});